import { Translation } from '@ps/web-shared-components';
import { addMilliseconds, addSeconds, format } from 'date-fns';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useTimer from '@swf/core/hooks/useTimer';
import { select } from '@swf/core/store';

import { TXTACL_SessionX_N0, TXTCLI_Limit } from './SessionTimer.messages.json';
import styles from './SessionTimer.scss';

export interface Props {
  showSeconds?: boolean;
  showLimit?: boolean;
  className?: string;
}

const timeZero = new Date(1970, 0, 1, 0, 0, 0);
let initialCount = 0;

const SessionTimer: React.FC<Props> = ({ showSeconds, className, showLimit }) => {
  const {
    userSessionStartTime = 0,
    loginTimeTotalSec = 0,
    loginTimeLimitMin
  } = useSelector(select.account.getLoginLimitInfo);

  const calculateElapsedTime = (): number => {
    const time = Date.now() - userSessionStartTime;
    return time > 0 ? time : 0;
  };

  const initialSessionTime = useMemo(calculateElapsedTime, [userSessionStartTime]);

  const sessionTime = useTimer({
    modifier: calculateElapsedTime,
    initial: initialSessionTime
  });

  const timeFormat = showSeconds ? 'HH:mm:ss' : 'HH:mm';
  const time = addMilliseconds(timeZero, sessionTime);
  const limitTime = useTimer({
    modifier: calculateElapsedTime,
    initial: 0
  });

  let sessionLimit = 0;
  if (loginTimeLimitMin === -1) {
    sessionLimit = 0;
    initialCount = limitTime;
  } else {
    const limitCount = initialCount > limitTime ? limitTime : limitTime - initialCount;
    sessionLimit = loginTimeTotalSec + Math.trunc(limitCount / 1000);
  }

  const helperDate = addSeconds(timeZero, sessionLimit);
  const sessionLimitStr = format(helperDate, timeFormat);

  return (
    <>
      <span className={className}>
        <span className={styles.hideMobile}>
          <Translation
            key={sessionTime}
            {...TXTACL_SessionX_N0}
            values={{ 0: format(time, timeFormat) }}
          />
        </span>
        <span className={styles.showMobile}>{format(time, timeFormat)}</span>
      </span>

      {showLimit && (
        <div className={className}>
          <Translation {...TXTCLI_Limit} />
          :&nbsp;{sessionLimitStr}
        </div>
      )}
    </>
  );
};

export default SessionTimer;
